<template>
  <div>
    <sFormItem
      prop="UpdateDateType"
      :rules="rules.UpdateDateType">
      <sSelect
        class="date-select-type"
        clearable
        data-qa="condition-props-list"
        :disabled="disabled"
        filterable
        :placeholder="$t('Common.Select')"
        :value="valueMutable.UpdateDateType"
        @update:value="sendValues('UpdateDateType', $event)">
        <sOption
          v-for="updateAutomationDateTypeItem in sprTypes"
          :key="`tender-contact-${updateAutomationDateTypeItem}`"
          :data-qa="`tender-contact-${updateAutomationDateTypeItem}`"
          :disabled="disabled"
          :label="$t(updateAutomationDateTypeItem)"
          :value="updateAutomationDateTypeItem"/>
      </sSelect>
    </sFormItem>
    <sFormItem
      v-if="currentComponent && currentComponent.component"
      prop="UpdateValue"
      :rules="rules.UpdateValue">
      <component
        :is="currentComponent.component"
        v-bind="currentComponent.options"
        :disabled="disabled"
        :value="valueMutable"
        @update:value="setParameters"/>
    </sFormItem>
  </div>
</template>
<script>
import automations from 'mixins/automations'
import automationActionDateCheckTime from 'components/automation/actions/dateComponents/automationActionDateCheckTime.vue'
import automationActionDateTime from 'components/automation/actions/dateComponents/automationActionDateTime.vue'
import automationActionTime from 'components/automation/actions/dateComponents/automationActionTime.vue'

export default {
  name: 'updateOfferPeriodEndDate',
  mixins: [ automations ],
  data() {
    const that = this
    return {
      rules: {
        UpdateDateType: {
          required: true,
          trigger: 'change',
          message: that.$t('Validate.Required'),
          validator(rule, value, callback) {
            if (!that.valueMutable.UpdateDateType) {
              callback(new Error(that.$t('Validate.Required')))
            }

            callback()
          }
        },
        UpdateValue: {
          type: 'object',
          trigger: 'change',
          validator(rule, value, callback) {
            if (!that.valueMutable.UpdateValue) {
              callback(new Error(that.$t('Validate.Required')))
            }
            if (that.valueMutable.UpdateDateType === 'SetDateTime') {
              if (that.valueMutable.UpdateValue.length == 6 || that.valueMutable.UpdateValue.length == 9) {
                callback(new Error(that.$t('Tenders.ChoiseDate')))
              }
              if (that.valueMutable.UpdateValue.length !== 16) {
                callback(new Error(that.$t('Tenders.IncorrectFormat')))
              }
            } else if (that.valueMutable.UpdateDateType === 'IncreaseBySpecificTime') {
              if (that.valueMutable.UpdateValue === '0.00:00:00') {
                callback(new Error(that.$t('Validate.Required')))
              }
            } else if (that.valueMutable.UpdateDateType === 'IncreaseDateByCountOfWorkingDays'
            || that.valueMutable.UpdateDateType === 'IncreaseDateByCountOfCalendarDays') {
              if (that.valueMutable.UpdateValue === '0.00:00:00') {
                callback(new Error(that.$t('Validate.Required')))
              }
              const splitValue = that.valueMutable.UpdateValue.split('.')
              if (that.valueMutable.NeedOverrideTime && splitValue[1] === '00:00:00') {
                callback(new Error(that.$t('Tenders.TimeNeed9to18')))

              }
            }
            callback()
          }
        },
      },
    }
  },
  methods: {
    setParameters(props) {
      const result = this.$_.cloneDeep(this.value)
      result.parameters = props
      this.$emit('update:value', result)
    },
    sendValues(key, props) {
      const result = this.$_.cloneDeep(this.value)
      const parameters = this.$_.cloneDeep(this.valueMutable)

      parameters[key] = props
      if (key === 'UpdateDateType') {
        parameters.UpdateValue = null
      }
      result.parameters = JSON.stringify(parameters)
      this.$emit('update:value', result)
    }
  },
  computed: {
    sprTypes() {
      return Object.keys(this.mixin_updateAutomationDateTypes)
    },
    valueMutable: {
      get() {
        const defaultModel = {
          UpdateDateType: null,
          NeedOverrideTime: false,
          UpdateValue: null,
        }
        let result = {}
        if (!this.value?.parameters) {
          result = defaultModel
        } else {
          try {
            result = JSON.parse(this.value.parameters) || defaultModel
          } catch {
            this.$notice.error({
              title: this.$t('Common.ErrorTitle'),
              message: this.$t('Automation.ErrorActionParams'),
              showClose: true,
              progress: true,
            })
            result = defaultModel
          }
        }
        if (!Object.keys(result)?.length) {
          result = defaultModel
        }
        return result
      }
    },
    currentComponent() {
      if (!this.valueMutable?.UpdateDateType) {
        return null
      }
      return this.mixin_updateAutomationDateTypes[this.valueMutable?.UpdateDateType]
    }
  },
  components: {
    automationActionDateCheckTime,
    automationActionDateTime,
    automationActionTime
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    additionalProps: {
      type: [Object, Array]
    },
  },
  i18n: {
    messages: {
      uk: {
        IncreaseDateByCountOfCalendarDays: 'На кількість календарних днів після дати запуску автоматзації',
        IncreaseDateByCountOfWorkingDays: 'На кількість робочих днів після дати запуску автоматзації',
        IncreaseBySpecificTime: 'На вказаний час',
        SetDateTime: 'На дату та час',
        CurrentDateTrigger: 'На дату коли відпрацювала автоматизація',
      },
      ru: {
        IncreaseDateByCountOfCalendarDays: 'На количество календарных дней после даты запуска автоматизации',
        IncreaseDateByCountOfWorkingDays: 'На количество рабочих дней после даты запуска автоматизации',
        IncreaseBySpecificTime: 'На указанное время',
        SetDateTime: 'На дату и время',
        CurrentDateTrigger: 'На дату, когда отработала автоматизация',
      },
      en: {
        IncreaseDateByCountOfCalendarDays: 'By the number of calendar days after the automation start date',
        IncreaseDateByCountOfWorkingDays: 'By the number of working days, after the automation start date',
        IncreaseBySpecificTime: 'At the specified time',
        SetDateTime: 'On date and time',
        CurrentDateTrigger: 'On the date when the automation worked',
      },
    }
  }
}
</script>
<style scoped lang="scss">
.date-select-type {
  margin-top: 12px;
  min-width: 540px;
}
</style>
